import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, NavigationExtras } from '@angular/router';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogModel, ConfirmationDialogComponent } from 'src/app/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-slave-admin',
  templateUrl: './slave-admin.component.html',
  styleUrls: ['./slave-admin.component.scss']
})
export class SlaveAdminComponent implements OnInit {

  page = 1;
  public role: any;
  public roleName: string;
  slaveAdminList: any = [];
  slaveAdmin_Id: any;
  closeResult: string;
  count: any;
  offsetUserList: any = 0 ;
  search: any = '';
  limit: any = 10;
  srcString: any='';
  constructor(private fb: FormBuilder, private modalService1: NgbModal, private dialog: MatDialog, private router: Router, private dashboardService: DashboardService,
    private toastr: ToastrService) {

    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    } else if (this.role == '3') {
      this.roleName = 'wms';
    } else if (this.role == '4') {
      this.roleName = 'normal';
    }
  }

  ngOnInit() {
    if (this.roleName == 'admin') {
      this.getAllSlaveAdmins(this.search, this.limit, this.offsetUserList);
    }
  }
// edit slave admin
  editSlave_admin(userId) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        'id': userId,
        'is_Editing': true
      }

    };
    this.router.navigate(['/inject-solar/add-slave-admin'], navigationExtras);
  }

  // get all slave admins list
  getAllSlaveAdmins(search, limit, offset) {
    if (offset == 0 ){
      this.page = 1;
    }
    var SlaveAdminObj = {
      search: search,
      limit: limit,
      offset: offset
    };
    this.dashboardService.getAllSlaveAdmins(SlaveAdminObj)
      // .pipe(takeUntil(this.ResponseVerifiedClearAlaramsNormalUser$))
      .subscribe(
        async result => {
          this.slaveAdminList = [];
          this.count = 0;
          if (result.status) {
            this.count = result.count;
            this.slaveAdminList = result.resultObject;
            this.toastr.success(result.message);

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {

          return console.error(err);

        }
      );
  }
  public confirmDialog(id: any): void {
    let message = "Are you sure you want to delete this User?";
    let title = "Confirm Action";
    const dialogData = new ConfirmDialogModel(title, message);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteSlaveAdminById(id);
      }
    });
  }
  // delete slave admin
  deleteSlaveAdminById(id) {
    var SlaveAdminObj = {
      slaveadmin_id: id
    };
    this.dashboardService.deleteSlaveAdmins(SlaveAdminObj)
      // .pipe(takeUntil(this.ResponseVerifiedClearAlaramsNormalUser$))
      .subscribe(
        async result => {

          if (result.status) {
            this.toastr.success(result.message);
            this.getAllSlaveAdmins(this.search, this.limit, this.offsetUserList);
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {

          return console.error(err);

        }
      );
  }
  // change password modal start
  openResetPasswordDialog(content, id) {
    this.slaveAdmin_Id = id;
    this.modalService1.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  changePasswordSlaveAdminById(formData) {
    var userChangePasswordRequestObject = {
      user_id: this.slaveAdmin_Id,
      new_password: formData.value.newPassword,
      confirm_password: formData.value.confirmPassword
    };
    this.dashboardService.changePasswordNormalAndWmsByUserId(userChangePasswordRequestObject)
      // .pipe(takeUntil(this.ResponseVerifiedClearAlaramsNormalUser$))
      .subscribe(
        async result => {
          if (result.status) {
            this.toastr.success("Password Changed Successfully!!");
            this.modalService1.dismissAll();
            // this.getAllSlaveAdmins();
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {

          return console.error(err);

        }
      );
  }

  // pagination for slave admin user list
  nextPageNew(page): void {
    this.offsetUserList = (page - 1) * 10;
    this.getAllSlaveAdmins(this.srcString, this.limit, this.offsetUserList);
}

}
